import {Container, media, Row} from '@modifi/ui'
import styled from 'styled-components'

export const PaddedContainer = styled(Container)`
  ${media.max.xs`
    padding: 0 40px;
  `}
`

export const StyledRow = styled(Row)`
  flex-direction: column;
  height: 100%;
`

type TopImageWrapperProps = {
  isImgLg?: boolean
}

export const TopImageWrapper = styled.div<TopImageWrapperProps>`
  margin-bottom: 16px;

  img {
    width: ${({isImgLg}): string => (isImgLg ? '100%' : '56px')};
  }
`

type BottomImageWrapperProps = {
  isImgLg?: boolean
}

export const BottomImageWrapper = styled.div<BottomImageWrapperProps>`
  margin-top: 16px;

  img {
    width: ${({isImgLg}): string => (isImgLg ? '100%' : '56px')};
  }
`
